var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button",attrs:{"id":"icon-button"}},[_c('img',{staticClass:"icon",attrs:{"src":_vm.icon}}),_vm._v(_vm._s(_vm.text)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }